/**
 * @generated SignedSource<<3a6e12beef2cb78ff9b1448dbfe932f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSignupPaymentMethodSelectQuery$variables = Record<PropertyKey, never>;
export type EventSignupPaymentMethodSelectQuery$data = {
  readonly session: {
    readonly user: {
      readonly squareCards?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly default: boolean;
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"PaymentMethod_squareCardOnFile">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"EventSignupPaymentMethodSelectModal_user">;
    } | null | undefined;
  } | null | undefined;
};
export type EventSignupPaymentMethodSelectQuery = {
  response: EventSignupPaymentMethodSelectQuery$data;
  variables: EventSignupPaymentMethodSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "default",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSignupPaymentMethodSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventSignupPaymentMethodSelectModal_user"
                  },
                  {
                    "alias": null,
                    "args": (v0/*: any*/),
                    "concreteType": "SquareCardOnFileConnection",
                    "kind": "LinkedField",
                    "name": "squareCards",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareCardOnFileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareCardOnFile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "PaymentMethod_squareCardOnFile"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "squareCards(enabled:true)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EventSignupPaymentMethodSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v0/*: any*/),
                    "concreteType": "SquareCardOnFileConnection",
                    "kind": "LinkedField",
                    "name": "squareCards",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareCardOnFileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareCardOnFile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cardBrand",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enabled",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expMonth",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expYear",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastFour",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "squareCards(enabled:true)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aff537413d51c36f674077c7e200b327",
    "id": null,
    "metadata": {},
    "name": "EventSignupPaymentMethodSelectQuery",
    "operationKind": "query",
    "text": "query EventSignupPaymentMethodSelectQuery {\n  session {\n    user {\n      __typename\n      ... on MemberUser {\n        ...EventSignupPaymentMethodSelectModal_user\n        squareCards(enabled: true) {\n          edges {\n            node {\n              id\n              default\n              ...PaymentMethod_squareCardOnFile\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment EventSignupPaymentMethodSelectModal_user on MemberUser {\n  squareCards(enabled: true) {\n    edges {\n      node {\n        id\n        ...SquareCardFragment\n      }\n    }\n  }\n}\n\nfragment PaymentMethod_squareCardOnFile on SquareCardOnFile {\n  id\n  expMonth\n  expYear\n  cardBrand\n  lastFour\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n"
  }
};
})();

(node as any).hash = "f993fa1d60d78ac14a446b417a1a2107";

export default node;
